import "../common";
import { onChangeAny } from "@escapio/portal/state/travelData";
import { getFavorites, onChangeHotels } from "../state/FavoriteHotels";
import {
	store,
	ACTION_SET_HOTELS,
	ACTION_RESET_PRICES,
} from "../components/favorites/DataStore";
import { checkVisibility } from "@escapio/shared/event/visibility-observer";
import "../components/favorites/SortingSelectorMobile";
import "../components/favorites/SortingSelectorDesktop";
import "../components/favorites/FilterDialogButton";
import "../components/favorites/PriceFilterSection";
import "../components/favorites/BoardFilter";
import "../components/favorites/ListHeaderCounter";
import "../components/favorites/EmptyMessage";
import "../components/favorites/HotelList";
import "@escapio/shared/components/ads/loader/GoogleAdwords";
import { FavoritesMapDialog } from "../components/map/FavoritesMapDialog";
import { triggerOnList as openDialog } from "../components/DialogOpener";

openDialog();

// Check visibility of lazy pictures when the store changes.
store.subscribe(checkVisibility);

store.dispatch(ACTION_SET_HOTELS, getFavorites());
onChangeHotels(favorites => store.dispatch(ACTION_SET_HOTELS, favorites));
onChangeAny(() => {
	store.dispatch(ACTION_RESET_PRICES);
});

let mapDialog = null;
document.querySelectorAll("[data-map-dialog-handler]").forEach(button =>
	button.addEventListener("click", event => {
		event.preventDefault();
		mapDialog = mapDialog || new FavoritesMapDialog();
		mapDialog.show();
	}),
);
